/**
 * Backend scopes that `@spazious/client-backoffice`'s `TokenAttributesScopesEnum`
 * does not export yet. They are gated on exactly like any enum member —
 * `hasScope()` takes plain strings — and the backend's 403 stays the backstop.
 *
 * TODO(SPAZ2-3259): drop these once the SDK regenerates with the catalog endpoints.
 */
export const TERMS_SCOPE_READ = 'read:terms-and-conditions';
export const TERMS_SCOPE_WRITE = 'write:terms-and-conditions';
export const TERMS_SCOPE_UPDATE = 'update:terms-and-conditions';
export const TERMS_SCOPE_DELETE = 'delete:terms-and-conditions';
